// extracted by mini-css-extract-plugin
module.exports = {"loader":"loader_6je6j","commentBox":"commentBox_3td4f"};